var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 19" }, props),
    React.createElement("path", { d: "M23.2.8a2.78 2.78 0 0 0-3.8 0L8.2 12 4.5 8.3a2.78 2.78 0 0 0-3.8 0 2.78 2.78 0 0 0 0 3.8l5.4 5.4a2.73 2.73 0 0 0 1.9.8h.2a2.73 2.73 0 0 0 1.9-.8l13-13a2.42 2.42 0 0 0 .1-3.7" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/checkmark.svg